import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { UserState } from '../recoil/user';
import NoozApi from '../../services/NoozApi';

export default ({ children }) => {
  const [user, setUser] = useRecoilState(UserState);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // SET USER GIFT CARDS
      if (user.email) {
        NoozApi.get('/customers/gift-cards')
          .then((response) => {
            if (response.data.gift_cards) {
              setUser({ ...user, giftCards: response.data });
            }
          })
          .catch(({ response }) => {
            console.log(response);
          });
      }
      if (
        user.availableShoppingCountries?.length === 0 ||
        !user?.availableShoppingCountries
      ) {
        // SET STORE AVAILABLE SHOPPING COUNTRIES
        setUser({ ...user, isLoading: true });
        NoozApi.get('/shopify/countries')
          .then((countriesResponse) => {
            if (countriesResponse.data) {
              setUser({
                ...user,
                availableShoppingCountries: countriesResponse.data,
                isLoading: false,
              });
            }
          })
          .catch((err) => console.log(err));
      }
    }
  }, [user.email]);

  useEffect(() => {
    if (typeof window !== 'undefined' && !user.email) {
      if (window.localStorage.userToken) {
        setUser({ ...user, isLoading: true });
        NoozApi.get('/customers/current')
          .then((response) => {
            if (response.data) {
              setUser({ ...user, ...response.data, isLoading: false });
            }
          })
          .catch((err) => console.log(err));
      } else {
        setUser({ ...user, isLoading: false });
      }
    }
  }, []);

  return children;
};
